import { render, staticRenderFns } from "./FormPalveluhakemusYritystiedot.vue?vue&type=template&id=6e540a20&scoped=true&"
import script from "./FormPalveluhakemusYritystiedot.vue?vue&type=script&lang=js&"
export * from "./FormPalveluhakemusYritystiedot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e540a20",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e540a20')) {
      api.createRecord('6e540a20', component.options)
    } else {
      api.reload('6e540a20', component.options)
    }
    module.hot.accept("./FormPalveluhakemusYritystiedot.vue?vue&type=template&id=6e540a20&scoped=true&", function () {
      api.rerender('6e540a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormPalveluhakemusYritystiedot.vue"
export default component.exports